module.exports = __webpack_public_path__ + "static/media/Statua_037.ce7a8422.jpg";